<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="col-md-12 d-flex justify-content-end">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createZscore()">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        <div class="row col-md-12 justify-content-center mt-2" v-if="listZscore != 0">
            <b-table
                :items="listZscore"
                :fields="fields"
                hover
                bordered
                responsive
                sticky-header="500px"
                small
                class="tblEstandar"
                head-variant="custom-blue"
                :per-page="perPage"
                :current-page="currentPage"
                @row-clicked="(item) => editZscore(item.id,item.vigencia)"
            >
                <template #cell(activo_corriente)="data">
                    <div class="text-right">{{ formatNumber(data.item.activo_corriente) }}</div>
                </template>
                <template #cell(activo_no_corriente)="data">
                    <div class="text-right">{{ formatNumber(data.item.activo_no_corriente) }}</div>
                </template>
                <template #cell(total_activo)="data">
                    <div class="text-right">{{ formatNumber(data.item.total_activo) }}</div>
                </template>
                <template #cell(pasivo_corriente)="data">
                    <div class="text-right">{{ formatNumber(data.item.pasivo_corriente) }}</div>
                </template>
                <template #cell(pasivo_no_corriente)="data">
                    <div class="text-right">{{ formatNumber(data.item.pasivo_no_corriente) }}</div>
                </template>
                <template #cell(total_pasivo)="data">
                    <div class="text-right">{{ formatNumber(data.item.total_pasivo) }}</div>
                </template>
                <template #cell(utilidad_acumulada)="data">
                    <div class="text-right">{{ formatNumber(data.item.utilidad_acumulada) }}</div>
                </template>
                <template #cell(total_patrimonio)="data">
                    <div class="text-right">{{ formatNumber(data.item.total_patrimonio) }}</div>
                </template>
            </b-table>
            <div class="row col-md-12 mt-1">
                <div class="col-md-10 d-flex justify-content-center">
                    <b-pagination
                    v-model="currentPage"
                    :total-rows="listZscore.length"
                    :per-page="perPage"
                    align="center"
                    size="md"
                    class="custom-pagination"
                    ></b-pagination>
                </div>
                <div class="col-md-2 d-flex justify-content-end">
                    <label class="mr-2 mb-0">Filas por página:</label>
                    <b-form-select
                    v-model="perPage"
                    :options="[5, 10, 20, 50, 100, 500]"
                    size="sm"
                    style="width: 80px;"
                    ></b-form-select>
                </div>
            </div>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <Crear :modalCrear="showModCrear" @cierraModal="closeModal"></Crear>
        <Detalle :modalEditar="showModEditar" :infoFinanciera="dataFinanciera" :infoConstante="infoConstante" @cierraModal="closeModal"></Detalle>
    </div>
</template>

<script>
import Crear from './Crear.vue';
import Detalle from './Detalle.vue';
import InformacionFinanciera from '../../../services/InformacionFinanciera';
import Constante from '../../../services/Constante';

export default {
    name : 'InformacionFinanciera',
    components : {Crear,Detalle},
    data: () => ({
        listZscore : [],
        showModCrear : false,
        showModEditar : false,
        dataFinanciera : [],
        dataConstante : [],
        infoConstante : [],
        perPage: 500,
        currentPage: 1,
        fields : [
            { key: 'vigencia', label: 'Vigencia', sortable: false },
            { key: 'activo_corriente', label: 'Activo corriente', sortable: false },
            { key: 'activo_no_corriente', label: 'Activo no corriente', sortable: false },
            { key: 'total_activo', label: 'Total activo', sortable: false },
            { key: 'pasivo_corriente', label: 'Pasivo corriente', sortable: false },
            { key: 'pasivo_no_corriente', label: 'Pasivo no corriente', sortable: false },
            { key: 'total_pasivo', label: 'Total pasivo', sortable: false },
            { key: 'utilidad_acumulada', label: 'Utilidad acumulada', sortable: false },
            { key: 'total_patrimonio', label: 'Total patrimonio', sortable: false },
        ],
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : 'Información Financiera',
                    noRow : "No hay registros",
                    vigencia : 'Vigencia',
                    activoCorriente : 'Activo corriente',
                    activoNoCorriente : 'Activo no corriente',
                    totalActivo : 'Total activo',
                    pasivoCorriente : 'Pasivo corriente',
                    pasivoNoCorriente : 'Pasivo no corriente',
                    totalPasivo : 'Total pasivo',
                    utilidadAcumulada : 'Utilidad acumulada',
                    totalPatrimonio : 'Total patrimonio',
                }
            }else{
                return {
                    title : 'Finantial information',
                    noRow : "There are not records",
                    vigencia : 'Validity',
                    activoCorriente : 'Current assets',
                    activoNoCorriente : 'Non-current asset',
                    totalActivo : 'Total assets',
                    pasivoCorriente : 'Passive current',
                    pasivoNoCorriente : 'Passive Non-Current',
                    totalPasivo : 'Total liabilities',
                    utilidadAcumulada : 'Accumulated profit',
                    totalPatrimonio : 'Total Assets',
                }
            }
        }
    },
    methods:{
        createZscore(){
            this.showModCrear = true
        },
        editZscore(id,vigencia){

            InformacionFinanciera.getInfoFinancieraById(id)
            .then((res) => {
                // console.log(res.data);
                this.dataFinanciera = res.data.infoFinancieraById[0]
                this.showModEditar = true
            })
            .catch((err) => console.log(err))

            Constante.getConstanteByVigencia(vigencia)
            .then((res) => {
                // console.log(res.data.constanteByVigencia);
                this.dataConstante = res.data.constanteByVigencia
                // console.log(this.dataConstante);
                let pos = this.dataConstante.length - 1
                // console.log(this.dataConstante[pos]);
                this.infoConstante = this.dataConstante[pos]
            })
            .catch((err) => console.log(err))
        },
        closeModal(val){
            this.showModCrear = val
            this.showModEditar = val
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(value);
        },
    },
    mounted(){
        InformacionFinanciera.getAllInformacionFinanciera()
        .then((res) => {
            // console.log(res.data);
            this.listZscore = res.data.infoFinanciera
        })
        .catch((err) => console.log(err))
    }
}
</script>

<style>

</style>